export interface StatusOptions {
  waitingText: string;
  successText: string;
  errorText: string;
  showSuccess: boolean;
  showBusy: boolean;
}
